import { resolveTypographyVariantStyles } from '@aspendental/themes';
import { Theme } from '@mui/material';

export const locationSearchCtrStyles = (theme: Theme, isLocationCardsInHeader?: boolean) => ({
	marginTop: '1.5rem',
	paddingX: { xs: 0, md: '1.25rem' },
	width: '100%',
	paddingTop: '1rem',
	position: 'sticky',
	top: 0,
	backgroundColor: isLocationCardsInHeader ? theme.palette.backgrounds?.white : theme.palette.backgrounds?.light,
	zIndex: 1,
});

export const locationSearchInputAndBtnCtrStyles = (isLocationCardsInHeader?: boolean) => ({
	flexDirection: { xs: 'column', md: 'row' },
	flexWrap: isLocationCardsInHeader ? 'wrap' : 'nowrap',
	gap: '1.25rem',
	width: '100%',
	paddingTop: {
		xs: '0.5rem',
		md: '1.25rem',
	},
	paddingBottom: {
		xs: 0,
		md: isLocationCardsInHeader ? 0 : '1.25rem',
	},
	justifyContent: { xs: 'flex-start', md: 'center' },
	alignItems: { xs: 'left', md: 'center' },
	position: 'relative',
});

export const getLocationSearchTextInputStyles = (theme: Theme) => ({
	display: 'flex',
	width: '100%',
	height: '3rem',
	backgroundColor: 'neutrals.white',
	border: `1px solid ${theme.palette.neutrals?.primary}`,
	borderRadius: '0.5rem',
	paddingRight: '.75rem !important',
	'& input::placeholder': {
		opacity: 1,
		fontWeight: '350',
		color: 'text.primary',
		fontSize: '1rem',
	},
	'& fieldset': {
		border: 'none',
	},
});

export const locationSearchLocateMeBtnStyles = (isLocationCardsInHeader?: boolean) => ({
	display: 'flex',
	textWrap: 'nowrap',
	width: { xs: 'auto', md: '100%' },
	justifyContent: isLocationCardsInHeader ? 'left' : 'center',
});

export const getHeadingStyles = (theme: Theme, titleVariant: string) => ({
	...resolveTypographyVariantStyles(theme, titleVariant),
});
